import { Chip, styled } from '@mui/material';
import { SessionTypeEnum } from '../lookup';

const sessionTypeColors: Record<SessionTypeEnum, string> = {
  [SessionTypeEnum.DYAD]: '#f9e4dd',
  [SessionTypeEnum.INDIVIDUAL]: '#e6e6e4',
  [SessionTypeEnum.GROUP]: '#cfd8eb',
};

export const SessionTypeChip = styled(Chip, {
  shouldForwardProp: (prop) => prop !== 'sessionTypeId',
})<{ sessionTypeId: SessionTypeEnum }>`
  background-color: ${({ sessionTypeId }) => sessionTypeColors[sessionTypeId]};
`;
